import React from 'react'
import { connect } from 'react-redux'
import FilesActions from '../../Redux/FilesRedux'
import CouponActions from '../../Redux/CouponRedux'

class UpdateBusinessImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      coupon: {
        tag: props.detail.tag || '',
        image_file: ''
      },
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let coupon = {...this.state.coupon}
      coupon['image_file'] = newProps.files.data.upload[0].filename
      this.setState({coupon})
    }
  }

  _fileSelect = (event) => {
    const file = event.target
    this.setState({ file })
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'coupon-image')
    
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.coupon}
    const data = {
      tag: this.props.detail.tag,
      form
    }

    this.props.updateCoupon(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h3 className="title">Update Coupon Image</h3>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className="form-group text-center">
            <label className="control-label">Current Image</label>
            <br/>
            <img alt={this.props.detail.image_file} title={this.props.detail.image_file} className="img-responsive" style={{ maxWidth: '100%' }} src={this.props.detail.image_url} /> 
          </div>
          <div className="form-group">
            <div className="row">
              <div className="col-3">
                <label htmlFor="image" className="control-label">New Image File (<span className="text-orange">433x433</span>)</label>
              </div>
              <div className="col-9">
                <div className="input-group">
                  <div className="custom-file">
                    <input type="file" className="custom-file-input" onChange={(event) => this._fileSelect(event)}/>
                    <label className="custom-file-label">
                      {this.state.file ? 'File selected' : 'Choose files'}
                    </label>
                  </div>
                  <div className="input-group-append">
                    <button onClick={(event) => this._upload(event)} disabled={!this.state.file} className="input-group-text">Upload</button>
                  </div>
                </div>
                { this.props.files.fetching && 'Uploading ...' }
                {this.state.uploaded ?
                  <div>
                    {this.props.files.data && this.props.files.data.upload.map((item, i) => {
                      return (
                        <img key={i} alt={item.filename} title={item.filename} className="img img-responsive" src={item.url} style={{ maxWidth: '100%' }}/>
                      )
                    })}
                  </div>
                  :
                  <div>
                    No Files Uploaded
                  </div>
                }
                {this.props.files.err && <div className="alert alert-danger">{ this.props.files.err }</div>}
              </div>
            </div>
          </div>
          <div className="text-right">
            <button type="button" className="btn btn-secondary mr-2" onClick={() => this.props.closeModal()}>Cancel</button>
            <button type="submit" disabled={!this.state.coupon.image_file} className="btn btn-primary">Save</button>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  updateCoupon: (data) => dispatch(CouponActions.businessUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateBusinessImage)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/UpdateBusinessImage.js